import React, { useState, useEffect } from "react";
import VisibilityApi from "../state/Visibility-api";
import { bookingsStore } from "../state/CommonState";
import { BsFillEyeFill } from "react-icons/bs";
import { BsDownload, BsXCircle } from "react-icons/bs";

const thStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "center",
  background: "#f4f4f4"
};

const tdStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "center"
};

const ShipmentJourney = ({ props }) => {
  const [data, setData] = useState({ milestones: [], myactions: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [showDocuments, setShowDocuments] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await VisibilityApi.getShipmentJourney(props.bookingId);
        setData(response);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [props.bookingId]);

  if (loading) return <p>Loading Shipment Journey...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!data.milestones.length && !data.myactions.length && !props?.exception?.length) return <p>No data available</p>;
  const shipmentScope = props.shipmentScope

  const renderMilestone = (title, items) => (
    <div style={{ marginBottom: "20px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "auto" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Milestone</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Date</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            if (
              (item.key === 'por_to_pol_movement' &&
              props?.por &&
              props?.pol &&
              props.por === props.pol) ||
              ((item.key === 'pod_arrival' || item.key === 'gateout_to_fpod')&&
              props?.pod &&
              props?.fpod &&
              props.pod === props.fpod)
            ) {
              return null;
            }

            return (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{(item.label === 'Gate-in at Cargo Terminal' && (shipmentScope === 'Door-to-Port' || shipmentScope === 'Door-to-Door')) ? "Arrival @ Dispatch Airport" : item.label}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.date}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  );

  const renderMyactions = (title, items) => (
    <div style={{ marginBottom: "20px" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "auto" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Action</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Initiated on</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Current Status</th>
            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Completed on</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>{item.actionName}</td>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.createdOn}</td>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.status === "PENDING" ? item.status + ' with ' + item.pendingWith : item.status}</td>
              <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.completedOn ? item.completedOn : "NA"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderVendor = (title, items) => {
    const filteredItems = items.filter(item =>
      !(item.vendorId === "N/A" && item.assignedTo === "N/A" && item.updatedBy === "N/A" && item.updatedAt === "N/A")
    );

    if (filteredItems.length === 0) return null;

    return (
      <div style={{ marginBottom: "20px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "auto" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Activity Name</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Vendor ID</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>User Assigned</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Updated By</th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center", background: "#f4f4f4" }}>Updated At</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                  {item.activityName
                    .split(" ")
                    .map((word, index) =>
                      index === 0 && word.length <= 3
                        ? word.toUpperCase()
                        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                    )
                    .join(" ")}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.vendorId}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.assignedTo}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.updatedBy}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>{item.updatedAt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const DocumentsCard = ({update}) => {

    const handleDownload = async (fileUrl, fileName) => {
        try {
            const response = await fetch(fileUrl);

            if (!response.ok) {
                throw new Error("Failed to download file");
            }

            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    const getFileType = (fileName = "") => {
        const extension = fileName.split(".").pop()?.toLowerCase();

        if (extension === "pdf") {
            return {
                label: "PDF",
                bg: "bg-[#EA580C]"
            };
        }

        if (
            ["png", "jpg", "jpeg", "webp", "pdf", "xlsx"].includes(extension)
        ) {
            return {
                label: "IMG",
                bg: "bg-[#30456F]"
            };
        }

        return {
            label: "DOC",
            bg: "bg-[#2563EB]"
        };
    };

    const getFileUrl = (file, pkey) => {
        return (
            `${process.env.REACT_APP_FILE_SERVER}` +
            `/api/v1/filestore/getfile/` +
            `${encodeURIComponent(pkey)}/` +
            `${encodeURIComponent(file)}`
        );
    };
    return (
        <div className="w-full max-w-[370px] rounded-2xl border border-gray-200 bg-white shadow-xl">
            <div className="flex justify-end border-b border-gray-200 px-5 pt-5">
                <button
                    type="button"
                    onClick={() => {
                        setShowDocuments(false)
                        setSelectedDocuments(null)
                    }}
                    className="text-gray-500 bg-[transparent] border-none hover:text-gray-800"
                >
                    <BsXCircle className="text-[#f14668]" size={16} />
                </button>
            </div>
            <div className="divide-y divide-gray-100">
                {update?.fileLink?.map((file, index) => {
                    const pkey = update?.pkey?.[index];

                    if (!file || !pkey) return null;

                    const fileType = getFileType(file);
                    const fileUrl = getFileUrl(file, pkey);

                    return (
                        <div
                            key={`${file}-${index}`}
                            className="flex items-center gap-3 px-5 py-3"
                        >
                            <div
                                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-xs font-bold text-white ${fileType.bg}`}
                            >
                                {fileType.label}
                            </div>
                            <div className="truncate min-w-0 flex-1">
                                <a
                                    target="_blank"
                                    href={fileUrl}
                                    rel="noreferrer"
                                    className="text-sm font-semibold text-[#3E5785]"
                                    title={file}
                                >
                                    {file}
                                </a>
                            </div>
                            <button
                                rel="noreferrer"
                                title={`Download ${file}`}
                                className="shrink-0 border-none bg-[transparent] text-gray-500 transition hover:text-blue-600"
                                onClick={() => handleDownload(fileUrl, file)}
                            >
                                <BsDownload size={18} />
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
  
  const renderException = (items) => {
    const hasMultipleUpdatedRemarks = items?.some(
        (item) => item.updatedRemarks?.length > 1
    );

    return (
        <div style={{ marginBottom: "20px" }}>
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    tableLayout: "auto"
                }}
            >
                <thead>
                    <tr>
                        {hasMultipleUpdatedRemarks && <th style={thStyle}></th>}
                        <th style={thStyle}>Exception Type</th>
                        <th style={thStyle}>Remarks</th>
                        <th style={thStyle}>Status</th>
                        <th style={thStyle}>Open Date/Time</th>
                        <th style={thStyle}>Close Date/Time</th>
                        <th style={thStyle}>Latest Updated By</th>
                        <th style={thStyle}>Notify Customer</th>
                        <th style={thStyle}>Docs</th>
                    </tr>
                </thead>

                <tbody>
                    {items.map((item, index) => {
                        console.log("ele?.updatedRemarks?.at(-1)?.notifyCustomer", item)
                        const updates = [
                            ...(item.updatedRemarks || [])
                        ].sort(
                            (a, b) =>
                                new Date(b.updated || 0) -
                                new Date(a.updated || 0)
                        );

                        const latestUpdate = updates[0] || null;
                        console.log("latestUpdate", latestUpdate)
                        const hasMultipleUpdates = updates.length > 1;

                        const isExpanded = expandedRows[index];

                        const formatDate = (date) => {
                            if (!date) return "-";

                            return new Date(date).toLocaleString(
                                "en-GB",
                                {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit"
                                }
                            );
                        };
                        return (
                            <React.Fragment key={index}>

                                <tr>
                                    {hasMultipleUpdatedRemarks &&<td
                                        style={{
                                            ...tdStyle,
                                            textAlign: "center",
                                            width: "45px"
                                        }}
                                    >
                                        {hasMultipleUpdates && (
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setExpandedRows((prev) => ({
                                                        ...prev,
                                                        [index]: !prev[index]
                                                    }))
                                                }
                                                style={{
                                                    border: "none",
                                                    background: "transparent",
                                                    cursor: "pointer",
                                                    fontSize: "16px"
                                                }}
                                            >
                                                {isExpanded ? "▼" : "▶"}
                                            </button>
                                        )}
                                    </td>}
                                    <td style={tdStyle}>
                                        {item.optionSelected?.label || "NA"}
                                    </td>
                                     <td style={{ ...tdStyle, whiteSpace: 'pre-line' }}>
                                         {latestUpdate?.remarks
                                             ? latestUpdate.remarks.replace(/<\/p>|<br\s*\/?>/gi, "\n").replace(/<[^>]*>/g, "").trim()
                                             : item.remarks?.replace(/<\/p>|<br\s*\/?>/gi, "\n").replace(/<[^>]*>/g, "").trim() || "NA"}
                                     </td>
                                    <td
                                        style={{
                                            ...tdStyle,
                                            color: item.isActive
                                                ? "green"
                                                : "red"
                                        }}
                                    >
                                        {item.isActive
                                            ? "Open"
                                            : "Closed"}
                                    </td>
                                    <td style={tdStyle}>
                                        {formatDate(item.open)}
                                    </td>
                                    <td style={tdStyle}>
                                        {formatDate(item.closed)}
                                    </td>
                                    <td style={tdStyle}>
                                        {latestUpdate?.updatedBy || "-"}
                                    </td>
                                    <td
                                        style={{
                                            ...tdStyle,
                                            textAlign: "center",
                                            color: latestUpdate?.notifyCustomer || item?.notifyCustomer
                                                ? "green"
                                                : "red"
                                        }}
                                    >
                                        {latestUpdate?.notifyCustomer || item?.notifyCustomer
                                            ? "✓ Yes"
                                            : "- No"}
                                    </td>
                                    <td style={{ ...tdStyle, width:'65px', position: "relative" }}>
                                        {latestUpdate?.pkey?.length > 0 && latestUpdate?.pkey[index] !== '' ? 
                                            <div
                                                className="relative overflow-visible"
                                            >
                                                <span 
                                                    className="flex align-center justify-center cursor-pointer text-gray-600 hover:text-blue-600 text-lg"
                                                    onClick={() => {
                                                        setSelectedDocuments(latestUpdate);
                                                        setShowDocuments(true);
                                                    }}>
                                                    <BsFillEyeFill />
                                                    <span className="ml-2">{`${latestUpdate.fileLink.length}`}</span>
                                                </span>

                                                {showDocuments && selectedDocuments === latestUpdate && (
                                                    <div className="absolute right-0 top-1/2 -translate-y-1/2 z-50 mt-2">
                                                        <DocumentsCard
                                                            update={latestUpdate}
                                                        />
                                                    </div>
                                                )}
                                            </div> : <span>-</span>
                                        }
                                    </td>

                                </tr>
                                {hasMultipleUpdates &&
                                    isExpanded &&
                                    updates.slice(1).map((update, updateIndex) => (
                                        <tr
                                            key={`${index}-update-${updateIndex}`}
                                            style={{
                                                background: "#f8fafc"
                                            }}
                                        >
                                            <td
                                                colSpan={11} // change based on your total table columns
                                                style={{
                                                    ...tdStyle,
                                                    padding: '8px 0px'
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "grid",
                                                        gridTemplateColumns:
                                                            "150px minmax(250px, 1fr) 145px 190px 135px 65px",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            color: "#64748b",
                                                            fontWeight: 600
                                                        }}
                                                    >
                                                        {updates.length - updateIndex - 1 === 1
                                                            ? "Created"
                                                            : `Update ${
                                                                updates.length -
                                                                updateIndex -
                                                                2
                                                            }`}
                                                    </div>
                                                     <div style={{ whiteSpace: 'pre-line' }}>
                                                         {update.remarks
                                                             ? update.remarks.replace(/<\/p>|<br\s*\/?>/gi, "\n").replace(/<[^>]*>/g, "").trim()
                                                             : "-"}
                                                     </div>
                                                    <div>
                                                        {formatDate(update.updated)}
                                                    </div>
                                                    <div>
                                                        {update.updatedBy || "-"}
                                                    </div>
                                                    <div style={{color: update?.notifyCustomer 
                                                        ? "green" : "red"}}>
                                                        {update?.notifyCustomer  ? "✓ Yes" : "- No"}
                                                    </div>

                                                    <div style={{position: "relative"}}> 
                                                        {update?.pkey?.length > 0 && update?.pkey[updateIndex] !== '' ? 
                                                            <div
                                                                className="relative overflow-visible"
                                                            >
                                                                <span 
                                                                    className="flex align-center justify-center cursor-pointer text-gray-600 hover:text-blue-600 text-lg"
                                                                    onClick={() => {
                                                                        setSelectedDocuments(update);
                                                                        setShowDocuments(true);
                                                                    }}>
                                                                    <BsFillEyeFill />
                                                                    <span className="ml-2">{`${update.fileLink.length}`}</span>
                                                                </span>

                                                                {showDocuments && selectedDocuments === update && (
                                                                    <div className="absolute right-0 top-1/2 -translate-y-1/2 z-50 mt-2">
                                                                        <DocumentsCard
                                                                            update={update}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </div> : <span>-</span>
                                                        }
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }

                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            
        </div>
    )
  };

  return (
    <div style={{ width: "100%" }}>
      {data.myactions.length > 0 && renderMyactions("Actions", data.myactions)}
      {data.milestones.length > 0 && renderMilestone("Milestones", data.milestones)}
      {data.vendor.length > 0 && renderVendor("Vendor", data.vendor)}
      {props?.exception?.length > 0 && renderException(props.exception)}
    </div>
  );
};

export default ShipmentJourney;
